import axios from "axios";

import { useMutation, useQuery } from "@tanstack/react-query";

const ARCHEM_URL = process.env.REACT_APP_API_URL; // + "purchasing/";

export const ARCHEM_MAIN_KEYS = {
    all: ['archem_main'],
    previewSignature: (userid, show, pagetype) => [...ARCHEM_MAIN_KEYS.all, { userid, show, pagetype }],
    getSignatureSettings: (userid, show) => [...ARCHEM_MAIN_KEYS.all, 'signatureSettings', { userid, show }],
    getUCAPDaysWithNoEntries: () => [...ARCHEM_MAIN_KEYS.all, 'ucapdayscount'],
}

export const useDigitalSignatureMutation = () => {
    return useMutation((params) => axios.post(ARCHEM_URL + 'purchasing/savedigitalsettings', params));
}

export const usePreviewSignatures = (_userid, _show, _pagetype) => {
    const getData = async (_user, _pt, _s) => {
        const { data } = await axios.get(ARCHEM_URL + 'purchasing/previewdigitalsignature', { params: { userid: _user, pagetype: _pt }, responseType: 'blob' });
        return data;
    }

    return useQuery(ARCHEM_MAIN_KEYS.previewSignature(_userid, _show, _pagetype), () => getData(_userid, _pagetype, _show), { enabled: !_show });
}

export const useUCAPGetDayCountWithNoEntries = () => {
    const getData = async () => {
        const { data } = await axios.get(ARCHEM_URL + 'ucap/getucapdaycountwithnoentries');
        return data;
    }

    return useQuery(ARCHEM_MAIN_KEYS.getUCAPDaysWithNoEntries(), getData);
}

export const useGetSignatureSettings = (_userid, _show) => {
    const getData = async (_user, _s) => {
        const { data } = await axios.get(ARCHEM_URL + 'purchasing/getdigitalsignaturesettings', { params: { userid: _user } });
        return data;
    }

    return useQuery(ARCHEM_MAIN_KEYS.getSignatureSettings(_userid, _show), () => getData(_userid, _show), { enabled: !_show });
}

export const useSetUserAsInactive = () => {
    return useMutation(params => axios.post(ARCHEM_URL + 'usermaintenance/makeuserinactive', params))
}